import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';

const TemplateLetterPage = () => {
  const managePage = 'Manage Template Letter';
  const addButton = "Add Template Letter";

  // Dummy Data for Template Letters
  const templetters = [
    { id: 1, templatename: "Template 1" },
    { id: 2, templatename: "Template 2" },
    { id: 3, templatename: "Template 3" }
  ];

  // Pagination (Dummy Values)
  const page = 1;
  const links = "<pagination-links>";

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      {/* Include Header Component */}
      <Header />

      <div id="content" className="">
        {/* Alert Box */}
        <AlertBox />

        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title pull-left">
              {managePage}
            </h4>
          </div>
          <div className="col-md-6" style={{ textAlign: 'right' }}>
            {/* <Link to={addPage}>Add Template</Link> */}
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          {templetters.length > 0 ? (
            <div className="table-responsive">
              <table className="table m-b-0">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>#</th>
                    <th>Template Name</th>
                    <th colSpan="2" style={{ width: '50px' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {templetters.map((post, index) => (
                    <tr key={post.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{page + index}</td>
                      <td>{post.templatename}</td>
                      <td style={{ width: '40px' }}>
                        {/* Assuming role-based access check */}
                        <Link to={`/Settings/TemplateLetter/add/${post.id}`} className="btn btn-warning btn-xs" style={{ float: 'left' }}>
                        <FontAwesomeIcon icon={faPencil} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoRecord />
          )}

          {/* Pagination Links */}
          {links && <div dangerouslySetInnerHTML={{ __html: links }} />}
        </div>
      </div>

      <input type="hidden" name="delid" id="delid" value="0" />

      {/* Modal for additional content */}
      <div id="myModal" className="modal">
        <div className="modal-dialog panel panel-default panel-border top">
          <div className="modal-content">
            <div id="myModalContent"></div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>

      {/* Include Footer Script */}
      <FooterScript />
    </div>
  );
};

const Header = () => (
  <header>
    {/* Dummy header component */}
    <h1>Header Component</h1>
  </header>
);

const AlertBox = () => (
  <div className="alert alert-success">
    {/* Dummy alert box */}
    Alert box message here!
  </div>
);

const NoRecord = () => (
  <div>No Records Found</div>
);

const FooterScript = () => (
  <footer>
    {/* Dummy footer script */}
    <h2>Footer Scripts here</h2>
  </footer>
);

export default TemplateLetterPage;
